import { useState } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Image } from "@components/anti/Image"
import Link from "@components/anti/Link"
import SwiperNavigation from "@components/global/SwiperNavigation"
import { dataLayerDigitalProduct } from "lib/datalayer"
import { useCustomNavSwiper, useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact, convertJson, imgUrl } from "src/mixins"

export function MTixSlider({ data, locale }) {
  const [trigger, anim] = useScrollAnim()
  const [swiperRef, handlePrev, handleNext] = useCustomNavSwiper()
  const [currentSlide, setCurrentSlide] = useState(0)
  const slideShow = convertJson(data?.slideshow)
  return (
    <section className="py-5 sc-mtix-slider" ref={trigger}>
      <div className="cinema-gradient" />
      <div className="container">
        <div className="row ">
          <div className="col-sm-4 col-left">
            <div>
              <div className="content-text">
                <h2 className={`h1 ${anim(1)}`}>
                  {/* {data && data[`title_${locale}`]} */}
                  {slideShow?.length &&
                    slideShow[currentSlide][`title_${locale}`]}
                </h2>
                <div className={`${anim(2)}`}>
                  {convertHtmlToReact(
                    slideShow?.length &&
                      slideShow[currentSlide][`description_${locale}`]
                  )}
                  {/* {convertHtmlToReact(data[`description_${locale}`])} */}
                </div>
              </div>
              <div className="row pb-5">
                <div
                  className={`col-6 ${anim(3)}`}
                  role="presentation"
                  onClick={() =>
                    dataLayerDigitalProduct({ apps_name: "App Store" })
                  }
                >
                  <Link target="_blank" href={data?.app_store_url}>
                    <Image
                      src="/img/badge/img_badge-appstore.svg"
                      alt="badge"
                      fill
                      className="img-fluid position-relative"
                    />
                  </Link>
                </div>
                <div
                  className={`col-6 ${anim(4)}`}
                  role="presentation"
                  onClick={() =>
                    dataLayerDigitalProduct({ apps_name: "Play Store" })
                  }
                >
                  <Link target="_blank" href={data?.play_store_url}>
                    <Image
                      src="/img/badge/img_badge-playstore.svg"
                      alt="badge"
                      fill
                      className="img-fluid position-relative"
                    />
                  </Link>
                </div>
              </div>
              <div className="d-sm-block d-none">
                {slideShow?.length > 1 ? (
                  <SwiperNavigation
                    theme="dark"
                    withAnim={anim(5)}
                    handleNext={handleNext}
                    handlePrev={handlePrev}
                  />
                ) : null}
              </div>
            </div>
          </div>

          <div className="col-sm-8">
            <Swiper
              ref={swiperRef}
              breakpoints={{
                640: {
                  slidesPerView: 1.5,
                  spaceBetween: 35,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 15,
                },
              }}
              slidesPerView={1.5}
              spaceBetween={35}
              centeredSlides
              className="mtix-swiper py-main overflow-visible"
              onSlideChange={(slide) => setCurrentSlide(slide?.realIndex)}
            >
              {slideShow?.map((item, i) => (
                <SwiperSlide key={i}>
                  <div
                    className={`d-flex justify-content-center ${anim(
                      i + 6,
                      "slideInRight"
                    )}`}
                  >
                    <Image
                      src={imgUrl(item?.image_mobile)}
                      className="img-fluid position-relative d-sm-none"
                      alt="image"
                      width="360"
                      height="664"
                    />
                    <Image
                      src={imgUrl(item?.image_desktop)}
                      className="img-fluid position-relative d-none d-sm-block"
                      alt="image"
                      width="260"
                      height="664"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  )
}
